import { ApplicationById } from "../../types/General";

type props = {
  type: any;
  data?: ApplicationById | null;
};

const DetailTop = ({ data }: props) => {
  return (
    <>
      <div className="cards profile_top">
        <div className="gap_p">
          <div className="left_s">
            <div className="profile_image">
              <figure>
                <img
                  src={
                    data?.profile_picture?.media_url ||
                    "/static/images/user_placeholder.png"
                  }
                  alt="Profile"
                />
                <span>
                  <img src="/static/images/verified_icon.svg" alt="Icon" />
                </span>
              </figure>
              <p> {data?.apk_id || ""}</p>
              {/* <Chip
                label={type
                  .split("-") // Split by hyphen
                  .map(
                    (word: string) =>
                      word.charAt(0).toUpperCase() + word.slice(1)
                  )
                  .join(" ")}
                backgroundColor="#E8F5E9"
                color="#4CAF50"
                style={{ width: "100%", textAlign: "center" }}
              /> */}
            </div>
            <div className="profile_info">
              <h2>
                <b>{`${data?.first_name} ${data?.last_name}`}</b>
              </h2>

              <ul className="text_list">
                <li>
                  <img src="/static/images/sms_icon.svg" alt="Icon" />{" "}
                  {data?.email ? (
                    <a
                      href={`mailto:${data?.email}`}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {data?.email}
                    </a>
                  ) : (
                    "-"
                  )}
                </li>
                {data?.phone_no ? (
                  <li>
                    <img src="/static/images/calling_icon.svg" alt="Icon" />
                    {data?.phone_no ? (
                      <a
                        href={`tel:${data?.country_code}${data?.phone_no}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {data?.country_code} {data?.phone_no}
                      </a>
                    ) : (
                      "-"
                    )}
                  </li>
                ) : null}
              </ul>

              {/* {type === USER_TYPE_SLUGS.INDIVIDUAL ? null : (
                <ul className="box_list">
                  <li>
                    <h3 style={{ textAlign: "center" }}>
                      <img
                        src="/static/images/application.png"
                        alt="Icon"
                        style={{ maxWidth: "30px" }}
                      />{" "}
                      25
                    </h3>
                    <p>Number of Visa Requests</p>
                  </li>
                </ul>
              )} */}
            </div>
          </div>
          <div className="right_s">
            <div className="profile_image">
              <p style={{ color: "black", paddingBottom: "6px" }}>
                Applier Details
              </p>
              <figure>
                <img
                  src={
                    data?.applier?.applier_profile_picture?.media_url ||
                    "/static/images/user_placeholder.png"
                  }
                  alt="Profile"
                />
              </figure>
              <p>{data?.applier?.applier_name || ""}</p>
              <p>{data?.applier?.applier_email || ""}</p>
            </div>

            {/* {type === USER_TYPE_SLUGS.COMPANY ? (
              <div className="profile_image">
                <p style={{ color: "black", paddingBottom: "6px" }}>
                  Representative
                </p>
                <figure>
                  <img
                    src={"/static/images/user_attachment.jpg"}
                    alt="Profile"
                  />
                </figure>
                <p>John Doe</p>
                <p>john@gmail.com</p>
              </div>
            ) : type === USER_TYPE_SLUGS.INDIVIDUAL ? (
              <div className="profile_image">
                <p style={{ color: "black", paddingBottom: "6px" }}>
                  Registered By
                </p>
                <figure>
                  <img
                    src={"/static/images/dummy-company.avif"}
                    alt="Profile"
                  />
                </figure>
                <p>Visa Inc. (Company)</p>
              </div>
            ) : null} */}
            {/* <div className="social_icons">
              <IconButton>
                <img src="/static/images/facebook_icon.svg" alt="Icon" />
              </IconButton>
              <IconButton>
                <img src="/static/images/instagram_icon.svg" alt="Icon" />
              </IconButton>
              <IconButton>
                <img src="/static/images/twitter_icon.svg" alt="Icon" />
              </IconButton>
              <IconButton>
                <img src="/static/images/youtube_icon.svg" alt="Icon" />
              </IconButton>
            </div> */}

            {/* <div className="progress_info">
              <h3>On time Delivery</h3>
              <div>
                <Slider
                  value={typeof value1 === "number" ? value1 : 0}
                  onChange={handleSliderChange1}
                  aria-labelledby="input-slider"
                />
                <Input
                  value={value1}
                  size="small"
                  onChange={handleInputChange1}
                  onBlur={handleBlur1}
                  inputProps={{
                    step: 10,
                    min: 0,
                    max: 100,
                    type: "number",
                    "aria-labelledby": "input-slider",
                  }}
                />
              </div>

              <h3>Quality of deliver</h3>
              <div>
                <Slider
                  value={typeof value2 === "number" ? value2 : 0}
                  onChange={handleSliderChange2}
                  aria-labelledby="input-slider"
                />
                <Input
                  value={value2}
                  size="small"
                  onChange={handleInputChange2}
                  onBlur={handleBlur2}
                  inputProps={{
                    step: 10,
                    min: 0,
                    max: 100,
                    type: "number",
                    "aria-labelledby": "input-slider",
                  }}
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailTop;
